import { UseFormMethods } from "react-hook-form";
import { Action } from "../../../libs/redux/action";
import {
    QUOTATION_POPUP_SUBMIT_FORM,
    QUOTATION_POPUP_SUBMIT_FORM_DONE,
    QUOTATION_POPUP_VALIDATE_DOCUMENT_NUMBER_ACTION,
    QUOTATION_POPUP_RESET_FORM,
    QUOTATION_POPUP_VALIDATE_DOCUMENT_NUMBER_DONE_ACTION,
    QUOTATION_POPUP_SET_CANNOT_OFFER_THIS_PRODUCT_POPUP_OPENED,
} from "../constants";
import { QuotationPopupState, quotationStateDefaultState } from "../state";
import {
    QuotationPopupFormModel,
    QuotationPopupFormModelRaw,
} from "../../../containers/quotation-popup/types/quotation-popup";

export class QuotationPopupValidateDocumentNumber extends Action<
    UseFormMethods<QuotationPopupFormModelRaw>,
    QuotationPopupState
> {
    readonly type = QUOTATION_POPUP_VALIDATE_DOCUMENT_NUMBER_ACTION;
    reducer(state: QuotationPopupState): QuotationPopupState {
        return {
            ...state,
            form: {
                ...state.form,
                validatingDocumentNumber: true,
            },
        };
    }
}

export class QuotationPopupValidateDocumentNumberDone extends Action<
    Error | boolean,
    QuotationPopupState
> {
    readonly type = QUOTATION_POPUP_VALIDATE_DOCUMENT_NUMBER_DONE_ACTION;
    reducer(state: QuotationPopupState): QuotationPopupState {
        if (this.error) {
            return {
                ...state,
                form: {
                    ...state.form,
                    validatingDocumentNumber: false,
                },
            };
        }
        return {
            ...state,
            form: {
                ...state.form,
                validatingDocumentNumber: false,
                isDocumentValidByEquifax: this.payload as boolean,
            },
        };
    }
}

export class QuotationPopupSubmitForm extends Action<
    {
        data: QuotationPopupFormModel;
        form: UseFormMethods<QuotationPopupFormModelRaw>;
    },
    QuotationPopupState
> {
    readonly type = QUOTATION_POPUP_SUBMIT_FORM;
    reducer(state: QuotationPopupState): QuotationPopupState {
        return {
            ...state,
            form: {
                ...state.form,
                submitting: true,
            },
        };
    }
}

export class QuotationPopupSubmitFormDone extends Action<
    void | Error,
    QuotationPopupState
> {
    readonly type = QUOTATION_POPUP_SUBMIT_FORM_DONE;
    reducer(state: QuotationPopupState): QuotationPopupState {
        return {
            ...state,
            form: {
                ...state.form,
                submitting: false,
            },
        };
    }
}

export class QuotationPopupResetForm extends Action<void, QuotationPopupState> {
    readonly type = QUOTATION_POPUP_RESET_FORM;
    reducer(state: QuotationPopupState): QuotationPopupState {
        return {
            ...state,
            form: quotationStateDefaultState.form,
            customerAlreadyHasPolicyPopup:
                quotationStateDefaultState.customerAlreadyHasPolicyPopup,
            cannotOfferThisProductPopup:
                quotationStateDefaultState.cannotOfferThisProductPopup,
        };
    }
}

export class QuotationPopupSetCustomerAlreadyHasPolicyPopupOpened extends Action<
    boolean,
    QuotationPopupState
> {
    readonly type = QUOTATION_POPUP_RESET_FORM;
    reducer(state: QuotationPopupState): QuotationPopupState {
        return {
            ...state,
            customerAlreadyHasPolicyPopup: {
                opened: this.payload,
            },
        };
    }
}

export class QuotationPopupSetCannotOfferThisProductPopupOpened extends Action<
    boolean,
    QuotationPopupState
> {
    readonly type = QUOTATION_POPUP_SET_CANNOT_OFFER_THIS_PRODUCT_POPUP_OPENED;
    reducer(state: QuotationPopupState): QuotationPopupState {
        return {
            ...state,
            cannotOfferThisProductPopup: {
                opened: this.payload,
            },
        };
    }
}
